import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	rowOrderHeader: {
		id: 'admin-pages-priorities.priorities-table.row-order-header',
		defaultMessage: 'Order',
		description:
			'Table header for the row numbers. The number 1 in this column represents the first row in the table, the number 2 represents the second row, and so on ',
	},
	iconAndNameHeader: {
		id: 'admin-pages-priorities.priorities-table.icon-and-name-header',
		defaultMessage: 'Icon and name',
		description: 'Table header for icon and name of priorities ',
	},
	descriptionHeader: {
		id: 'admin-pages-priorities.priorities-table.description-header',
		defaultMessage: 'Description',
		description: 'Table header for description of priorities',
	},
	colorHeader: {
		id: 'admin-pages-priorities.priorities-table.color-header',
		defaultMessage: 'Color',
		description: 'Table header for color of priorities',
	},
	schemesHeader: {
		id: 'admin-pages-priorities.priorities-table.schemes-header',
		defaultMessage: 'Schemes',
		description: 'Table header for priority schemes associated with priorities',
	},
	actionsHeader: {
		id: 'admin-pages-priorities.priorities-table.actions-header',
		defaultMessage: 'Actions',
		description: 'Table header for actions to take for priorities',
	},
});
